<template>
    <v-layout column>
        <v-layout justify-space-between align-center>
            <div class="ml-2 mb-1">Payment History: </div>
            <v-btn
                data-testid="hide-history-btn"
                class="hide-history-btn error"
                small
                @click="hideHistory"
            >Hide History</v-btn>
        </v-layout>
        <v-flex>
            <v-data-table
                :items="paymentHistory"
                :headers="headers"
                :custom-sort="customSort"
                :options.sync="pagination"
                :footer-props="{'items-per-page-options': pagination.itemsPerPageOptions}"
                no-data-text="There is no payment history for this unit."
            >
                <template slot="item" slot-scope="props">
                  <tr>
                    <td data-testid="history-date-paid">{{ formatDate(props.item.date) }}</td>
                    <td data-testid="history-amount">${{ props.item.amount.toFixed(2) }}</td>
                    <td data-testid="history-description">{{ props.item.description }}</td>
                    <td data-testid="history-receipt">{{ props.item.receipt }}</td>
                  </tr>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
/* eslint-disable eqeqeq */
import moment from "moment";
import { paymentHistoryHeaders } from "@/helpers/tenant-rentals/payment-history-data-table-headers";

export default {
  name: "PaymentHistory",
  props: {
    paymentHistory: {
      type: Array
    }
  },
  data() {
    return {
      pagination: {
        itemsPerPage: 25,
        itemsPerPageOptions: [25, 50, 75, 100],
        totalItems: this.paymentHistory.length,
        sortBy: ["date"],
        sortDesc: [true]
      },

      headers: paymentHistoryHeaders
    };
  },
  methods: {
    formatDate(date) {
      return new moment(date).format("MM/DD/YYYY");
    },
    hideHistory() {
      this.$emit("hideHistory");
    },
    customSort(items, index, isDescending) {
      items.sort((a, b) => {
        if (index == "date") {
          let date1 = new Date(a.date).getTime();
          let date2 = new Date(b.date).getTime();
          if (isDescending) {
            return date2 - date1;
          } else {
            return date1 - date2;
          }
        } else {
          if (isDescending) {
            return b[index] > a[index] ? 1 : -1;
          } else {
            return a[index] > b[index] ? 1 : -1;
          }
        }
      });
      return items;
    }
  }
};
</script>
